export default __webpack_public_path__ + "static/video-cover-01b43f51499a461b79a68b1c1374cf99.jpg";